import { render, staticRenderFns } from "./AddPPMnew.vue?vue&type=template&id=7644b446&scoped=true"
import script from "./AddPPMnew.vue?vue&type=script&lang=ts"
export * from "./AddPPMnew.vue?vue&type=script&lang=ts"
import style0 from "./AddPPMnew.vue?vue&type=style&index=0&id=7644b446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7644b446",
  null
  
)

export default component.exports